import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { commonLabels } from "../../common.labels";

@Component({
  selector: 'app-input-file',
  templateUrl: './input-file.component.html',
  styleUrls: ['./input-file.component.scss']
})
export class InputFileComponent {
  @Input() formGroup: FormGroup;
  theme = 'marketplace-default';
  @Input() labels: any;
  @Output() emitDelete = new EventEmitter();
  @Output() emitFileChangeEvent = new EventEmitter();
  @ViewChild('zipInput') zipInputVariable: ElementRef;
  className = 'input-file';

  deleteAppVersionFile() {
    this.emitDelete.emit(this.zipInputVariable);
  }

  fileChangeEvent(fileInput: any) {
    this.emitFileChangeEvent.emit({ fileInput, zip: this.zipInputVariable });
  }

  protected readonly commonLabels = commonLabels;
}
